// redux/user/user.actions.js
import UserActionTypes from "./user.types";

export const setCurrentUser = (userData) => ({
  type: UserActionTypes.SET_CURRENT_USER,
  payload: userData,
});

export const setFavoriteStation = (favoriteStationId) => ({
  type: UserActionTypes.SET_FAVORITE_STATION,
  payload: favoriteStationId,
});

export const signOut = () => ({
  type: UserActionTypes.SET_CURRENT_USER_NULL,
});

export const setUsers = (users) => ({
  type: UserActionTypes.SET_USERS,
  payload: users,
});

export const setConnectedUsers = (connectedusers) => ({
  type: UserActionTypes.SET_CONNECTED_USERS,
  payload: connectedusers,
});

export const setOpen = (state) => ({
  type: UserActionTypes.SET_OPEN,
  payload: state,
});

export const setEntitlement = (state) => ({
  type: UserActionTypes.SET_ENTITLEMENT,
  payload: state,
});
